module.exports = __webpack_public_path__ + "static/media/0210_IMG_LE_SOL_LEGNI_WALNUT.cb8b1c92.png";